<template>
  <div>
    <div class="flex-container panel-head align-top mb-0">
      <div class="flex-item">
        <p>
          {{$t('INDENT_SOURCE_DEPOT')}} :
          <strong>{{order.sources[0].details.name}}</strong>
        </p>
        <p>
          {{$t('INDENT_TRANSPORTER')}} :
          <strong>{{order.transporter.name}}</strong>
        </p>
      </div>
      <div class="flex-item text-right">
        <p>
          {{$t('INDENT_CREATION_DATE')}} :
          <strong>{{$moment(order.created_at).format("DD-MMM-YYYY")}}</strong>
        </p>
        <p>
          {{$t('INDENT_VEHICLE_TYPE')}} :
          <strong>{{order.vehicle_type.type}}</strong>
        </p>
      </div>
    </div>
    <p>
      {{$t('INDENT_STATUS')}} :
      <span v-bind:class="getStatus(order.status)">
        <span class="order-status-button pt-0">
          {{$t(statusName(order.status))}}
        </span>
      </span>
    </p>

    <div class="sub-head d-flex align-item-bottom mt-20">
      {{$t('INDENT_GROUPED_INDENTS')}}
      <div class="ml-auto" v-if="selectedAction === indentActions.ASSIGN_TRUCK">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_ASSIGN_VEHICLE')}}
        </Button>
      </div>

      <div class="ml-auto" v-else-if="selectedAction === indentActions.UPDATE_TRUCK">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_UPDATE_VEHICLE')}}
        </Button>
      </div>

      <div class="ml-auto" v-else-if="selectedAction === indentActions.START_LOAD">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_START_LOAD')}}
        </Button>
      </div>

      <div class="ml-auto" v-else-if="selectedAction === indentActions.END_LOAD">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_END_LOAD')}}
        </Button>
      </div>

      <div class="ml-auto" v-else-if="selectedAction === this.indentActions.TRUCKIN">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_TRUCK_IN')}}
        </Button>
      </div>

      <div class="ml-auto" v-else-if="selectedAction === this.indentActions.TRUCKOUT">
        <Button type="secondary" :disabled="!groupedIndents.length" @click="$emit('changeTab')">
          {{$t('INDENT_TRUCK_OUT')}}
        </Button>
      </div>
    </div>

    <div class="table-with-action">
      <Table
        :data="groupedIndents"
        :stripe="true"
        max-height="250px"
        class="table-striped table-xl blank-striped bordered my-15"
      >
        <TableColumn label="Indent ID" width="200">
          <template slot-scope="scope">
            {{scope.row.order_no}}
          </template>
        </TableColumn>
        <TableColumn label="Destination" width="160">
          <template slot-scope="scope">
            {{displayDestination(scope, routerSourceAndDestinationType.DEPOT)}}
          </template>
        </TableColumn>
        <TableColumn label="Consignee">
          <template slot-scope="scope">
            <span>
              {{displayDestination(scope, routerSourceAndDestinationType.CONSIGNEE)}}
            </span>
            <span class="action-row no-bg" v-if="!order.ptl_group_id && order.order_number !== scope.row.order_no" @click="openPopup(scope.$index)">
              <Tooltip class="item" effect="dark" placement="top">
                <div slot="content" class="tooltipcontent">Remove</div>
                <svgicon name="icon-link-broken" width="14" height="14"/>
              </Tooltip>
            </span>
          </template>
        </TableColumn>
      </Table>
      <div v-if="showAutoGroup" class="popover-custom popover-fixed no-border popup-top">
        <div class="popover-body bg-white w-350">
          <div class="popover-header">
            {{$t('INDENT_REMOVE_FROM_AUTO_GROUP')}}
          </div>
          <p>
            {{$t('INDENT_REMOVED_AUTO_GROUP_CONFIRM_MSG')}}
          </p>
          <div class="popover-footer">
            <Button type="secondary" size="mini" @click="showAutoGroup=false">
              {{$t('INDENT_CANCEL')}}
            </Button>
            <Button type="primary" size="mini" @click="$emit('removeIndentGroup',selectedIndex), showAutoGroup=false">
              {{$t('INDENT_CONFIRM')}}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { routerSourceAndDestinationType, indentActions } from '@/constants/order';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    ptlGroups: {
      type: Array,
      default: () => [],
    },
    selectedAction: {
      type: String,
    },
  },
  data() {
    return {
      indentActions,
      routerSourceAndDestinationType,
      tableData: null,
      disableVehicle: '',
      showAutoGroup: false,
      selectedIndex: null,
    };
  },
  computed: {
    groupedIndents() {
      return (this.ptlGroups.length && this.ptlGroups[0].orderData) || [];
    },
    isValidIndentStatus() {
      return this.$statusUtil.getStatusIds(['indented', 'indent_accepted', 'indent_assign_due',
        'indent_accept_due', 'indent_arrived_due']).includes(this.order.status);
    },
  },
  methods: {
    displayDestination(scope, entityType) {
      return scope.row.destinationDetails.filter(dest => dest.type === entityType).map(dest => dest.name).join(' , ') || '-';
    },
    openPopup(index) {
      this.selectedIndex = index;
      this.showAutoGroup = true;
    },
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId) &&
        mainStatus.find(status => status.id === mainStatusId).tlabel;
    },
    getStatus(id) {
      return `order-status-${this.$statusUtil.getMainStatusName(id)}`;
    },
  },
};
</script>
